import { Interface } from '@ethersproject/abi'
import { ChainId } from '@mimoprotocol/swap-sdk'
import V1_EXCHANGE_ABI from './v1_exchange.json'
import V1_FACTORY_ABI from './v1_factory.json'

const V1_FACTORY_ADDRESSES: { [chainId in ChainId]: string } = {
  [ChainId.MAINNET]: '0xda257cBe968202Dea212bBB65aB49f174Da58b9D', // TODO
  [ChainId.IOTEXTESTNET]: '0xda257cBe968202Dea212bBB65aB49f174Da58b9D'
}

const V1_FACTORY_INTERFACE = new Interface(V1_FACTORY_ABI)
const V1_EXCHANGE_INTERFACE = new Interface(V1_EXCHANGE_ABI)

export { V1_FACTORY_ADDRESSES, V1_FACTORY_INTERFACE, V1_FACTORY_ABI, V1_EXCHANGE_INTERFACE, V1_EXCHANGE_ABI }
